<div
    class="tpc-card"
    [style.animation-delay.ms]="post?.animationDelayMs || 0"
>
    <div class="tpc-header">
        <div class="tpc-avatar">
            <img *ngIf="profileImgUrl() as src" [src]="src" alt="" (error)="onAvatarError()" />
            <span *ngIf="!profileImgUrl()">{{ avatarLetter() }}</span>
        </div>
        <div class="tpc-names">
            <p class="tpc-display">{{ post?.profileName }}</p>
            <p class="tpc-handle"><span>&#64;</span>{{ post?.userName }}</p>
        </div>
        <span *ngIf="post?.categoryTag" class="tpc-tag">{{ post?.categoryTag }}</span>
    </div>
    <p class="tpc-body">{{ post?.postContent }}</p>
    <div class="tpc-stats">
        <span class="tpc-stat">
            <svg class="tpc-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
            </svg>
            {{ post?.likes | number }}
        </span>
        <span class="tpc-stat">
            <svg class="tpc-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M17 1l4 4-4 4" />
                <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                <path d="M7 23l-4-4 4-4" />
                <path d="M21 13v2a4 4 0 0 1-4 4H3" />
            </svg>
            {{ post?.reposts | number }}
        </span>
        <span class="tpc-stat">
            <svg class="tpc-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            </svg>
            {{ post?.comments | number }}
        </span>
    </div>
</div>
